import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, Fragment as _Fragment, normalizeClass as _normalizeClass, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "_flex _jc-sb _ai-c _fd-c _fd-r--m"
}
const _hoisted_2 = { class: "_mt-0" }
const _hoisted_3 = { class: "_flex _ai-c _gap-3 _shrink-0" }
const _hoisted_4 = ["onClick"]

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_base_button = _resolveComponent("base-button")
  const _component_base_notificator = _resolveComponent("base-notificator")
  const _component_persistent_toggle = _resolveComponent("persistent-toggle")

  return (_openBlock(), _createBlock(_component_persistent_toggle, {
    "storage-key": $props.notification.storageKey
  }, {
    default: _withCtx(({ close }) => [
      _createVNode(_component_base_notificator, {
        type: $props.notification.type,
        class: _normalizeClass($props.notification.class),
        "can-close": $props.notification.canClose,
        qa: $props.notification.qa,
        onClose: close
      }, {
        default: _withCtx(() => [
          ($props.notification.action)
            ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("span", _hoisted_2, _toDisplayString($props.notification.message), 1 /* TEXT */),
                _createElementVNode("div", _hoisted_3, [
                  ($props.notification.canDismiss)
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 0,
                        class: "_pa-0 _mx-1 _tdu",
                        onClick: _withModifiers(close, ["prevent"])
                      }, "Dismiss", 8 /* PROPS */, _hoisted_4))
                    : _createCommentVNode("v-if", true),
                  _createVNode(_component_base_button, {
                    theme: "transparentInverse",
                    onClick: _withModifiers($props.notification.action.onClick, ["prevent"]),
                    "data-qa": `notificator-button:${$props.notification.action.label}`
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString($props.notification.action.label), 1 /* TEXT */)
                    ]),
                    _: 1 /* STABLE */
                  }, 8 /* PROPS */, ["onClick", "data-qa"])
                ])
              ]))
            : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                _createTextVNode(_toDisplayString($props.notification.message), 1 /* TEXT */)
              ], 64 /* STABLE_FRAGMENT */))
        ]),
        _: 2 /* DYNAMIC */
      }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["type", "class", "can-close", "qa", "onClose"])
    ]),
    _: 1 /* STABLE */
  }, 8 /* PROPS */, ["storage-key"]))
}